import React, { Component } from 'react';
import './school.scss';
import PaginationComponent from "../common/cw-pagination/cw-pagination"
import Header from '../common/header/header-component';
import Loading from '../common/loading/loading';
import AddSchool from "./add-school/add-school";
import { ImageConstants, Constants } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source'

class School extends Component {

    state = {
        meta: { totalPages: 0, page: 1, count: 0 },
        schools: []
    };

    componentDidMount() {
        this.getSchools()
    }

    getSchools() {
        // SchoolApi.getSchools({}).then(response => {
        //     console.log("Success", response)
        //     this.setState({ schools: response.response, meta: response.meta })
        // }).catch(err => {
        //     console.log("Error", err)
        // })
    }

    showAddSchool = () => {
        this.setState({ showAddSchool: true })
    }

    closeAddSchool = () => {
        this.setState({ showAddSchool: false, selectedSchool: null })
    }

    onSaveSchool = () => {
        this.getSchools()
        this.closeAddSchool()
    }

    onEdit = (item) => {
        this.setState({ selectedSchool: item, showAddSchool: true })

    }

    onDelete = () => {
        this.getSchools()
    }

    render() {
        return (
            <div>
                {this.state.isLoading && <Loading> </Loading>}
                <Header from={'VERIFY_SCREEN'} />
                <div className="school">
                    <div className="text-right">
                        <img src={getImageSource(ImageConstants.ONBOARD_TOP_RIGHT)} className='vector-image-top-right' />
                    </div>
                    <div>
                        <AddSchool isConfirmDetail headerTitle="Please confirm your details" school={this.state.selectedSchool} back={this.closeAddSchool} onSave={this.onSaveSchool} />
                    </div>
                    <div className="text-right px-0">
                        <img src={getImageSource(ImageConstants.ONBOARD_BOTTOM_RIGHT)} className='vector-image-bottom-right' />
                    </div>
                </div>
            </div>
        )
    }
}

export default School;